import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setServiceDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : 'not-scrolled'}`}>
      <Link to="/products">
        <img src="/images/logo.png" alt="ZFlow Logo" className="navbar-logo" />
      </Link>
      <div className="navbar-links">
        <Link
          to="/about"
          className={`navbar-link ${location.pathname === '/about' ? 'active' : ''}`}
        >
          회사소개
        </Link>
        <Link
          to="/technology"
          className={`navbar-link ${location.pathname === '/technology' ? 'active' : ''}`}
        >
          기술
        </Link>
        <div className="navbar-item" ref={dropdownRef}>
          <Link
            to="/products"
            className={`navbar-link ${location.pathname === '/products' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              setServiceDropdownOpen(!serviceDropdownOpen);
            }}
          >
            서비스
          </Link>
          <div className={`navbar-dropdown-menu ${serviceDropdownOpen ? 'open' : 'closed'}`}>
            <Link
              to="/products"
              className={`navbar-dropdown-item ${location.pathname === '/products' ? 'active' : ''}`}
              onClick={() => setServiceDropdownOpen(false)}
            >
              전체 서비스
            </Link>
            <Link
              to="/products/pig-farm"
              className={`navbar-dropdown-item ${
                location.pathname === '/products/pig-farm' ? 'active' : ''
              }`}
              onClick={() => setServiceDropdownOpen(false)}
            >
              스마트 돼지 농장 관리 시스템
            </Link>
            <Link
              to="/products/wasp-system"
              className={`navbar-dropdown-item ${
                location.pathname === '/products/wasp-system' ? 'active' : ''
              }`}
              onClick={() => setServiceDropdownOpen(false)}
            >
              AI 말벌 퇴치 시스템
            </Link>
            <Link
              to="/products/aas"
              className={`navbar-dropdown-item ${location.pathname === '/products/aas' ? 'active' : ''}`}
              onClick={() => setServiceDropdownOpen(false)}
            >
              AAS
            </Link>
            <Link
              to="/products/ai"
              className={`navbar-dropdown-item ${location.pathname === '/products/ai' ? 'active' : ''}`}
              onClick={() => setServiceDropdownOpen(false)}
            >
              AI
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
